<template>
  <Card class="widget-height-md ivu-card-custom" shadow>
    <div slot="title" class="with-icon">
      <h4>Leads Processed</h4>
      <Icon type="ios-link" size='24' title='Customized Form Answers' @click="questionnaireProcessed"></Icon>
    </div>
    <div class="widget-data full-height">
      <Table :columns="dataColumns" :data="items" class="full-height show-borders initial-height"
             border shadow stripe></Table>
      <Page v-show="showPager" :total="dataCount" :page-size="pageSize"
            show-total show-sizer :page-size-opts="pageSizer" transfer
            @on-change="changeSelectedPage" @on-page-size-change="changePageSize">
      </Page>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
    <LeadsProcessedForm ref="leadsProcessedForm"></LeadsProcessedForm>
    <SurveyProcessed ref="SurveyProcessed"></SurveyProcessed>
    <Modal v-model="confirmDelete"
           title="Are you sure you want to delete this item permanently ?"
           @on-ok="remove_Form(currentDeleteIndex)"
           ok-text="Continue" class-name="vertical-center-modal card-modal" :width="480">
      <div class="confirmation-body">
        <p>
          <Icon type="md-help-circle" size="24" color="#f90"/>
          <span>{{confirmDeleteMessage}}</span></p>
        <p class="submessage">*all associated data will be erased</p>
      </div>
      <div slot="footer">
        <Button class="btn btn-outline-secondary btn-sm" @click="confirmDelete=false">Cancel</Button>
        <Button class="submit btn btn-danger btn-sm" type="error"
                @click="remove_Lead(currentDeleteIndex);confirmDelete=false">Delete
        </Button>
      </div>
    </Modal>
  </Card>
</template>
<script>
  import moment from 'moment-timezone';
  import {deleteLeadForm, getLeadsProcessed} from '../../services/LeadForms.service'
  import {getSurveyProcessedByEvent} from '../../services/SurveyForms.service'
  import LeadsProcessedForm from './_LeadsProcessedForm'
  import SurveyProcessed from './_surveyProcessed'
  import {bus} from '../../main'
  import {mapGetters} from 'vuex'
  import Router from '../../router';

  export default {
    components: {
      LeadsProcessedForm, SurveyProcessed
    },
    data() {
      return {
        surveys: [{
          surveyFormId: null,
          formId: null,
          leadId: null,
          formName: null,
          firstName: null,
          lastName: null,
          company: null,
          email: null,
          questions: [{
            questionId: 0,
            formId: null,
            label: '',
            type: '',
            inputType: '',
            fieldCode: '',
            order: 0,
            visible: false,
            answer: [{
              questionId: 0,
              answerType: '',
              answerValue: '',
              fieldCode: ''
            }],
            choices: [{
              actionOnSync: null,
              choiceId: 0,
              label: '',
              order: 0,
              questionId: 0
            }]
          }],
          hasSurveys: false,
        }],
        spinShow: true,
        confirmDelete: false,
        confirmDeleteMessage: '',
        currentDeleteIndex: null,
        getVisibleDatasetCount: 0,
        dataCount: 0,
        pageSizer: [25, 50, 100],
        pageSize: 25,
        historyData: [],
        showPager: false,
        dataColumns: [
          {
            title: 'Form Name',
            key: 'formName',
            sortable: true,
            align: 'left',
            minWidth: 80,
            className: 'paddingIndent',
          },
          {
            title: 'First Name',
            key: 'firstName',
            sortable: true,
            align: 'left',
            minWidth: 80,
            className: 'paddingIndent',
          },
          {
            title: 'Last Name',
            key: 'lastName',
            sortable: true,
            align: 'left',
            minWidth: 80,
            className: 'paddingIndent',
          },
          {
            title: 'Email',
            key: 'email',
            sortable: true,
            align: 'left',
            minWidth: 80,
            className: 'paddingIndent',
          },
          {
            title: 'CreationDate',
            key: 'createdDate',
            sortable: true,
            align: 'left',
            minWidth: 80,
            className: 'paddingIndent',
            render: (h, params) => {
              if (params.row.createdDate) {
                let result = h('span', moment(params.row.createdDate).format('YYYY-MM-DD hh:mm a'));
                return result;
              } else {
                let result = h('span', '');
                return result;
              }
            },
          },
          {
            title: 'Lead Creator',
            key: 'createdBy',
            sortable: true,
            align: 'left',
            minWidth: 80,
            className: 'paddingIndent',
          },
          {
            title: 'Action',
            key: 'action',
            align: 'left',
            minWidth: 150,
            maxWidth: 150,
            className: 'paddingIndent',
            render: (h, params) => {
              const self = this;
              let listIcon = null;
              if (params.row.hasSurveys) {
                listIcon = h('Icon', {
                  props: {
                    type: 'ios-list',
                    size: '24'
                  },
                  attr: {
                    title: "Survey Processed"
                  },
                  on: {
                    click: () => {
                      let _event = localStorage.getItem('selected_event');
                      let evnt = this.getEventList.filter(a => a.eventId === parseInt(_event) ||
                        a.eventName === _event)[0];
                      getSurveyProcessedByEvent(params.row.leadId, evnt.eventId)
                        .then(res => {
                          if (res.data) {
                            if (res.data.length > 1) {
                              self.$refs.SurveyProcessed.openSurveys('VIEW SURVEY PROCESSED', 'view');
                              self.$refs.SurveyProcessed.setTitleValue(res.data, params.index);
                            } else {
                              Router.push({name: 'QuestionnaireProcessed'});
                              setTimeout(() => {

                              }, 300);
                            }
                          }
                        });
                    }
                  }
                })
              }
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-eye-outline',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      self.$refs.leadsProcessedForm.openLeadsProcessedForm('VIEW LEAD PROCESSED', 'view');
                      self.$refs.leadsProcessedForm.setFormValue(params.row, params.index);
                    }
                  }
                }),
                h('Icon', {
                  props: {
                    type: 'ios-create-outline',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      self.$refs.leadsProcessedForm.openLeadsProcessedForm('EDIT LEAD PROCESSED', 'edit');
                      self.$refs.leadsProcessedForm.setFormValue(params.row, params.index);
                    }
                  }
                }),
                h('Icon', {
                  props: {
                    type: 'ios-close-circle-outline',
                    color: '#9b3035',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      self.confirmDeleteMessage = `${params.row.formName}`;
                      self.confirmDelete = true;
                      self.currentDeleteIndex = params.index;
                    }
                  }
                }),
                listIcon
              ]);
            }
          }
        ],
        items: [{
          leadFormId: null,
          formId: null,
          leadId: null,
          formName: null,
          firstName: null,
          lastName: null,
          company: null,
          email: null,
          questions: [{
            questionId: 0,
            formId: null,
            label: '',
            type: '',
            inputType: '',
            fieldCode: '',
            order: 0,
            visible: false,
            answer: {
              questionId: 0,
              answerType: '',
              answerValue: '',
              fieldCode: '',
              others: null
            },
            choices: [{
              actionOnSync: null,
              choiceId: 0,
              label: '',
              order: 0,
              questionId: 0
            }]
          }],
          hasSurveys: false,
        }],
      }
    },
    computed: {
      ...mapGetters(['getEvent', 'getEventList'])
    },
    methods: {
      getLeadFormsData() {
        this.showPager = false;
        let localCompany = localStorage.getItem('selected_company');
        let localEvent = localStorage.getItem('selected_event');

        let company = JSON.parse(localStorage.getItem('companies'))
          .filter(a => a.companyName === localCompany || a.companyId === parseInt(localCompany))[0];

        let event = JSON.parse(localStorage.getItem('events'))
          .filter(a => a.eventName === localEvent || a.eventId === parseInt(localEvent))[0];

        if (company && event) {

          getLeadsProcessed(false, company.companyId, event.eventId)
            .then(response => {
              this.items = [];
              let result = response.data;
              result.map(leadFormData => {
                let newData = {};
                newData.active = leadFormData.active;
                newData.leadFormId = leadFormData.leadFormId;
                newData.leadId = leadFormData.leadId;
                newData.formId = leadFormData.formId;
                newData.formName = leadFormData.formName;
                newData.createdBy = leadFormData.createdBy;
                newData.createdDate = new Date(leadFormData.createdDate);
                newData.allowOther = leadFormData.allowOther;
                newData.hasSurveys = leadFormData.hasSurveys;
                if (leadFormData.questions) {
                  newData.questions = [];
                  leadFormData.questions.map((qs) => {
                      let newQuestion = qs;

                      newQuestion.formId = leadFormData.formId;
                      if (!newQuestion.fieldCode) {
                        newQuestion.fieldCode =
                          newQuestion.label ? newQuestion.label.replace('.', '').replace(/\s/g, '-') : '';
                      }
                      newQuestion.status = false;
                      newQuestion.visible = true;
                      if (newQuestion.label) {
                        if (newQuestion.label.toLowerCase() != 'id') {
                          newQuestion.status = true;
                        }
                      }
                      newQuestion.answers = [];
                      if (leadFormData.answers) {
                        let answerVal = leadFormData.answers.filter(a => a.questionId == newQuestion.questionId);
                        if (answerVal) {
                          if (answerVal.length > 0) {
                            answerVal.map((i) => {

                                //check for main fields
                                if (newQuestion.fieldCode.indexOf('first') > -1) {
                                  newData.firstName = i.answerValue;
                                }
                                if (newQuestion.fieldCode.indexOf('last') > -1) {
                                  newData.lastName = i.answerValue;
                                }
                                if (newQuestion.fieldCode.indexOf('company') > -1) {
                                  newData.company = i.answerValue;
                                }
                                if (newQuestion.fieldCode.indexOf('email') > -1) {
                                  newData.email = i.answerValue;
                                }

                                let ansText = '';
                                let choices = qs.choices;
                                let hasChoices = choices !== null ? (choices.length > 0) : false;
                                if (hasChoices) {
                                  let validArray = this.isJsonString(i.answerValue);
                                  if (validArray) {
                                    let arr = JSON.parse(JSON.stringify(i.answerValue));
                                    for (let n = 0; n < arr.length; n++) {
                                      choices
                                        .filter(c => c.choiceId === arr[n])
                                        .map(c => {
                                          ansText += c.label + ',';
                                        });
                                    }
                                    ansText = ansText.replace(/,\s*$/, '').replace(/,/g, ' - ');
                                    i.answerValue = ansText;
                                  }
                                }
                                let newAnswer = {
                                  questionId: newQuestion.questionId,
                                  answerType: i.answerType,
                                  answerValue: i.answerValue,
                                  fieldCode: newQuestion.fieldCode,
                                  others: null
                                };
                                if (newData.allowOther) {
                                  let inputType = newQuestion.inputType;
                                  if (inputType == 'multiChoice' || inputType == 'singleChoice') {
                                    newAnswer.others = 'Others';
                                  }
                                }
                                newQuestion.answers.push(newAnswer);
                              }
                            );
                            let label = newQuestion.label ? newQuestion.label : '';
                            if (label.indexOf("last") > -1) {
                              newData.lastName = newQuestion.answers[0].answerValue;
                            }
                            if (label.indexOf("company") > -1) {
                              newData.company = newQuestion.answers[0].answerValue;
                            }
                            if (label.indexOf("email") > -1) {
                              newData.email = newQuestion.answers[0].answerValue;
                            }
                          } else {
                            let answerData = {
                              questionId: newQuestion.questionId,
                              answerType: 'string',
                              answerValue: '',
                              fieldCode: newQuestion.fieldCode,
                              others: null
                            };
                            newQuestion.answers.push(answerData);
                          }
                        } else {
                          let answerData = {
                            questionId: newQuestion.questionId,
                            answerType: 'string',
                            answerValue: '',
                            fieldCode: newQuestion.fieldCode,
                            others: null
                          };
                          newQuestion.answers.push(answerData);
                        }
                      }

                      //choices
                      let choices = [];
                      if (qs.choices) {
                        if (qs.choices.length != 0) {
                          qs.choices
                            .filter(a => a.questionId == qs.questionId || a.questionId == 0)
                            .map((c, ix) => {
                              let choiceData = {};
                              choiceData.choiceId = c.choiceId == 0 ? ix : c.choiceId;
                              choiceData.questionId = qs.questionId;
                              choiceData.icon = c.icon;
                              choiceData.label = c.label;
                              choiceData.order = c.order;
                              choiceData.action = c.action;
                              choices.push(choiceData);
                            });
                        }
                      }
                      newQuestion.choices = choices;
                      newData.questions.push(newQuestion);
                    }
                  );
                }

                this.items.push(newData);
              });
              this.items.sort((a, b) => (a.createdDate < b.createdDate) ? 1 : ((b.createdDate < a.createdDate) ? -1 : 0));
              this.historyData = this.items;
              this.spinShow = false;
              this.dataCount = this.items.length;

              if (this.historyData.length < this.pageSize) {
                this.items = this.historyData;
              } else {
                this.items = this.historyData.slice(0, this.pageSize);
              }
              if (this.items.length > 0) {
                this.showPager = true;
              }
            });
        } else {
          this.showPager = false;
          this.items = [];
          this.spinShow = false;
        }
      },
      showSpin() {
        this.spinShow = true;
      },
      remove_Lead(index) {
        deleteLeadForm(this.items[index].leadFormId, true).then(response => {
          this.items.splice(index, 1);
          this.$Message.success('Lead Form successfully deleted!');
        }).catch(error => {
          this.$Message.error('Failed deleting lead form');
        })
      },
      changePageSize(size) {
        this.pageSize = size;
        this.changeSelectedPage(1);
      },
      changeSelectedPage(index) {
        let _start = (index - 1) * this.pageSize;
        let _end = index * this.pageSize;
        this.items = this.historyData.slice(_start, _end);
      },
      questionnaireProcessed() {
        bus.$emit('getActiveLink', 'QuestionnaireProcessed');
        setTimeout(() => {
          bus.$emit('getQuestionnaireProcessed');
        }, 100);
      },
      isJsonString(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      }
    },
    created() {
      this.items = [];
      this.getLeadFormsData();
    },
    mounted() {
      this.items = [];
      this.getLeadFormsData();
      bus.$on('changeLeadsProcessedForms', (eventName, companyName) => {
        this.items = [];
        this.companyName = companyName;
        this.eventName = eventName;
        this.spinShow = true;
        this.getLeadFormsData();
      });
    }
  }
</script>
<style scoped>

  .ivu-table td {
    height: 50px;
  }

  .ivu-card-custom {
    overflow: auto;
    height: auto;
  }


  .ivu-table table tbody tr td {
    vertical-align: top;
  }

  .ivu-table-wrapper:not(.show-borders) .ivu-table table tbody tr:last-of-type td {
    vertical-align: top;
    padding-top: 0;
  }

  .ivu-table .table-cell-custom {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ivu-table-cell .ivu-poptip,
  .ivu-table-cell .ivu-table-sort {
    position: absolute;
    right: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/c_LeadsProcessed/_LeadsProcessed.vue